import { render, staticRenderFns } from "./Datapoints.vue?vue&type=template&id=969ecdfc&scoped=true&"
import script from "./Datapoints.vue?vue&type=script&lang=js&"
export * from "./Datapoints.vue?vue&type=script&lang=js&"
import style0 from "./Datapoints.vue?vue&type=style&index=0&id=969ecdfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969ecdfc",
  null
  
)

export default component.exports